import React from 'react';
import MiniHeaders from "./mini-headers";
import '../components-css/about-course.scss'

const AboutCourse = () => {
    return (
        <div className={'blocks-wrapper'}>
            <MiniHeaders headerName={'Դասընթացի մասին'}/>
            <div>
                <p>Դասընթացը նախատեսված է նրանց համար, ովքեր ցանկանում են աշխատել ազատ գրաֆիկով և ունենալ բարձր եկամտով
                    աշխատանք, ինչպես նաև ունեն ձգտում սովորելու և նոր մասնագիտություն ձեռք բերելու:</p>
                <br/>
                <h4>Այս դասընթացի շնորհիվ`</h4>
                <br/>
                <ul className={'course'}>
                    <li>
                        <p>
                            Ընդամենը 1 ամսում ձեռք կբերեք մասնագիտություն, որը Ձեզ կընձեռնի հնարավորություն լինել
                            ֆինանսապես անկախ։
                        </p>
                    </li>
                    <li>
                        <p>
                            Կդառնաք վաճառքի մասնագետ ամենամեծ մարկետփլեյսներից մեկում և
                            կունենաք աշխատանքային լայն և եկամտաբեր հնարավորություններ։</p>
                    </li>
                    <li>
                        <p>
                            Կսովորեք ինչպես ընտրել վաճառքի ապրանք, որտեղից և ում միջոցով այն ձեռք բերել, տեղափոխել WB-ի
                            պահեստ և ինչ
                            քայլեր ձեռնարկել, որ ունենաք լավ վաճառքներ։
                        </p>
                    </li>
                    <li>
                        <p>Կանցնեք խորացված ուսուցում և պրակտիկա։</p>
                    </li>
                </ul>
                <br/>
                {/*<p>Այս դասընթացի շնորհիվ դուք ընդամենը 1 ամսում ձեռք կբերեք մասնագիտություն, որը Ձեզ կընձեռնի հնարավորություն լինել ֆինանսապես անկախ։</p>*/}
                {/*<br/>*/}
                {/*<p>Այս դասընթացի արդյունքում դուք կդառնաք վաճառքի մասնագետ ամենամեծ մարկետփլեյսներից մեկում և*/}
                {/*    կունենաք աշխատանքային լայն և եկամտաբեր հնարավորություններ։</p>*/}
                {/*<br/>*/}
                {/*<p>Դասընթացին շրջանակներում դուք կանցնեք խորացված ուսուցում և պրակտիկա։</p>*/}
                {/*<br/>*/}
                <p>Դասընթացին մասնակցելու համար պետք չեն նախնական գիտելիքներ և հմտություններ, այլ ընդամենը անհրաժեշտ է
                    Excel-ի բազային գիտելիքներ։</p>
                <br/>
                <p>Ամեն ինչ ուսուցանվում է 0-ից։</p>
            </div>
            <div className={'about-course-img'}/>
        </div>
    );
};

export default AboutCourse;
